import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { categoriesArrayPropTypes, userPropTypes } from 'helpers/propTypes';

import useWindowSize from '../../../../hooks/useWindowSize';
import LogoContainer from 'containers/LogoContainer';

import './NavBarD8.scss';

const NavBarD8 = (props) => {
  const {
    cartSize, categories, closeMenu, handleClick, isMenuActive, isUserLoggedIn, openMenu,
    openSearchModal, openRegisterModal, openLoginModal, logout, user, showCatalogo, client,
    hasFrequentQuestions = false,
  } = props;
  const size = useWindowSize();

  const renderUserLoggedOutButtons = () => (
      <div>
      <div className="navbar-icon-d8" role="presentation" onClick={openLoginModal}>
        <i className="fa fa-sign-in" aria-hidden="true" />
      </div>
      <li>
        <div className="navbar-icon-d8" role="presentation" onClick={openRegisterModal}>
          <i className="fa fa-user-plus" aria-hidden="true" />
        </div>
      </li>
    </div>
  );

  const renderUserLoggedInButtons = () => (
    <div>
      <Link to="/perfil">
        <div className="navbar-icon-d8">
          <i className="fa fa-user" aria-hidden="true" />
        </div>
      </Link>
      <li>
        <div className="navbar-icon-d8" role="presentation" onClick={logout}>
          <i className="fa fa-sign-out" aria-hidden="true" />
        </div>
      </li>
    </div>
  );

  const renderResponsiveMenu = () => (
    <>
      <div
        className={`fs-menu-overlay-d8${isMenuActive ? ' pointer-active-d8' : ''}`}
        role="presentation"
        onClick={closeMenu}
      />
      <div className={`hamburger-menu-d8${isMenuActive ? ' active-d8' : ''}`}>
        <div
          className="hamburger-close-d8"
          role="presentation"
          onClick={closeMenu}
        >
          <i className="fa fa-times" aria-hidden="true" />
        </div>
        <div className="hamburger-menu-content-d8">
          <ul className="menu-top-nav-d8">
            <li role="presentation" onClick={closeMenu}>
              <NavLink to="/home" activeClassName="active" data-testid="nav-home">
                Home
              </NavLink>
            </li>
            <li role="presentation" onClick={closeMenu}>
              <NavLink to="/productos" activeClassName="active" data-testid="nav-products">
                Categorías
              </NavLink>
            </li>
            <li role="presentation" onClick={closeMenu}>
              <NavLink to="/ofertas" activeClassName="active" data-testid="nav-offers">
                Ofertas
              </NavLink>
            </li>
            {hasFrequentQuestions && (
              <li role="presentation" onClick={closeMenu}>
                <NavLink to="/preguntas-frecuentes" activeClassName="active">
                  Preguntas frecuentes
                </NavLink>
              </li>
            )}
            {showCatalogo &&
              <li role="presentation" onClick={closeMenu}>
                <NavLink to="/catalogos" activeClassName="active">
                  Catálogo
                </NavLink>
              </li>
            }
            <li role="presentation" onClick={closeMenu}>
              <NavLink to="/contacto" activeClassName="active">
                Contacto
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  );

  return (
    <div data-testid="navbar">
      <div className="main-nav-container-d8">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 p-0">
              <nav className="navbar-d8">
                <div className="navbar-content-d8">
                  <div className="navbar-logo-d8">
                    <LogoContainer />
                  </div>
                  <ul className="navbar-menu-d8" onClick={handleClick}>
                    {size.width > 991 && (
                      <li role="presentation">
                        <ul className="navbar-menu-icons-d8">
                          {client?.phone && (
                            <li>
                              <a href={`tel:${client.phone}`} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-phone" />
                              </a>
                            </li>
                          )}
                          {(client?.email_info || client?.email) && (
                            <li>
                              <a href={`mailto:${client?.email_info || client?.email}`} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-envelope-o" />
                              </a>
                            </li>
                          )}
                          {client?.link_fb && (
                            <li>
                              <a href={client.link_fb} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-facebook" />
                              </a>
                            </li>
                          )}
                          {client?.link_ig && (
                            <li>
                              <a href={client.link_ig} target="_blank" rel="noopener noreferrer">
                                <i className="fa fa-instagram" />
                              </a>
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                    <li role="presentation" onClick={closeMenu}>
                      <NavLink to="/home" activeClassName="active" data-testid="nav-home">
                        Home
                      </NavLink>
                    </li>
                    <li className="products-menu-link-d8">
                      <NavLink to="/productos" activeClassName="active" data-testid="nav-products">
                        Categorías
                      </NavLink>
                    </li>
                    <li className="products-menu-link-d8">
                      <NavLink to="/ofertas" activeClassName="active" data-testid="nav-offers">
                        Ofertas
                      </NavLink>
                    </li>
                    {hasFrequentQuestions && (
                      <li role="presentation" onClick={closeMenu}>
                        <NavLink to="/preguntas-frecuentes" activeClassName="active">
                          Preguntas frecuentes
                        </NavLink>
                      </li>
                    )}
                    {showCatalogo && (
                      <li role="presentation" onClick={closeMenu}>
                        <NavLink to="/catalogos" activeClassName="active">
                          Catálogo
                        </NavLink>
                      </li>
                    )}
                    <li role="presentation" onClick={closeMenu}>
                      <NavLink to="/contacto" activeClassName="active" data-testid="nav-contact">
                        Contacto
                      </NavLink>
                    </li>
                    {isUserLoggedIn && (
                      <li role="presentation" onClick={closeMenu}>
                        <NavLink to="/compras" activeClassName="active">
                          Mis compras
                        </NavLink>
                      </li>
                    )}
                  </ul>
                  <ul className="navbar-user-d8 p-0">
                    <li>
                      <div className="navbar-icon-d8" role="presentation" onClick={openSearchModal}>
                        <i className="fa fa-search" aria-hidden="true" />
                      </div>
                    </li>
                    <li>
                      <Link to="/carrito">
                        <div className="navbar-icon-d8">
                          <i className="fa fa-shopping-cart" aria-hidden="true" />
                          <span id="checkout-items" className="checkout-items-d8">
                            {cartSize}
                          </span>
                        </div>
                      </Link>
                    </li>
                    <li>
                      {user ? renderUserLoggedInButtons() : renderUserLoggedOutButtons()}
                    </li>
                  </ul>
                  <div
                    className="hamburger-container-d8"
                    role="presentation"
                    onClick={openMenu}
                  >
                    <i className="fa fa-bars" aria-hidden="true" />
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {renderResponsiveMenu()}
    </div>
  );
};

NavBarD8.propTypes = {
  cartSize: PropTypes.number.isRequired,
  categories: categoriesArrayPropTypes.isRequired,
  closeMenu: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  isMenuActive: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  openMenu: PropTypes.func.isRequired,
  openSearchModal: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  openLoginModal: PropTypes.func.isRequired,
  openRegisterModal: PropTypes.func.isRequired,
  showCatalogo: PropTypes.bool,
  hasFrequentQuestions: PropTypes.bool,
  user: userPropTypes,
  client: PropTypes.shape(),
};

NavBarD8.defaultProps = {
  showCatalogo: false,
  hasFrequentQuestions: false,
  user: null,
  client: null,
};

export default NavBarD8;
